const THREE = require('three')

class TextureCache {

  constructor(options) {
    this.textures = {}
  } 

  createTexture(url, options){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img); 
    texture.wrapS = options.wrap || THREE.RepeatWrapping;
    texture.wrapT = options.wrap || THREE.RepeatWrapping;  
    texture.magFilter = options.magFilter || THREE.LinearFilter;
    texture.minFilter = options.minFilter || THREE.LinearFilter;
    // texture.anisotropy = 0; 
    texture.needsUpdate = true;
    this.textures[url] = texture;
    return texture; 
  }

  getTexture(url){
    return this.textures[url];
  }
 
}

let texturecache = new TextureCache()
export default texturecache